var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-carousel',{attrs:{"autoplay":"","arrows":""}},[_c('div',[_c('water-wen-statistics')],1),_c('div',[_c('hydrology-wen',{attrs:{"dataMap":_vm.dataMap}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }